import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {StartWorkoutFromTemplateInput, WorkoutRepository} from '../ports/workout.repository';

export class StartWorkoutFromTemplate implements UseCase<[StartWorkoutFromTemplateInput], Workout> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: StartWorkoutFromTemplateInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.startWorkoutFromTemplate(input);
  }
}
